export default __webpack_public_path__ + "resources/icons/d410-5d03.webp";